import script from "./TopMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TopMenu.vue?vue&type=script&setup=true&lang=js"

import "./TopMenu.vue?vue&type=style&index=0&id=8ea680e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ea680e0"]])

export default __exports__